<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import ItemBlocks from '../../item/blocks/ItemBlocks.svelte';

    let { choice } = $props();
</script>

{#if choice.blockTree}
    <ItemBlocks blockTree={choice.blockTree} />
{:else}{choice.content}{/if}
